import collect from 'collect.js';
import { useSelector } from 'react-redux';
import { StoreInterface } from '../../store/types';
import { useMemo } from 'react';

export default function useRewardAccount() {
  const { company, reward_account } = useSelector((store: StoreInterface) => store.initialData);

  const rewards = useMemo(
    () => reward_account?.rewards ?? company?.loyalty_program?.rewards ?? [],
    [reward_account?.rewards, company?.loyalty_program?.rewards],
  );

  const balance = useMemo(() => reward_account?.balance ?? 0, [reward_account?.balance]);

  const availableReward = useMemo(() => collect(rewards).last((item) => item.is_available), [rewards]);

  const nextReward = useMemo(() => collect(rewards).first((item) => item.cost > balance), [rewards, balance]);

  const maxReward = useMemo(() => collect(rewards).last(), [rewards]);

  const progress = useMemo(() => (balance / nextReward?.cost) * 100, [balance, nextReward]);
  const maxRewardProgress = useMemo(() => (balance / maxReward?.cost) * 100, [balance, maxReward]);

  const hasFreeItem = maxReward?.is_available && maxReward?.discount === 100;

  return {
    balance,
    progress,
    maxRewardProgress,
    rewards,
    nextReward,
    maxReward,
    availableReward,
    hasFreeItem,
  };
}
